import { createSlice } from "@reduxjs/toolkit";

const getUfFromStores = cnpjEmpresa => {
  const { storesSelecteds, stores: headerStores } = JSON.parse(
    window.localStorage.getItem("app-headerData") || "{}",
  );
  const stores =
    storesSelecteds?.length > 0 ? storesSelecteds
    : headerStores?.length > 0  ? headerStores
    : JSON.parse(window.localStorage.getItem("@mixfiscal:stores") || "[]");

  const getUf = s => s?.mxf?.cli_uf || s?.state;

  if (cnpjEmpresa) {
    const uf = getUf(stores.find(s => s?.cnpj === cnpjEmpresa));
    if (uf) return uf;
  }
  return getUf(stores[0]) || "SP";
};

const inicitalState = () => {
  const getUnicUfStore = getUfFromStores();

  const initialProducts = {
    data: {},
    show: false,
    isFilterEan: true,
    filter: {
      ufEntrada: getUnicUfStore,
      origem: "EI",
      ufSaida: getUnicUfStore,
      saida: "SAC",
    },
    filterEanDesc: {},
  };

  return initialProducts;
};
export const productEanGtinSlice = createSlice({
  name: "produtoEanGtin",
  initialState: inicitalState(),
  reducers: {
    handleOpenModalProduct: (state, { payload }) => {
      state.show = true;
      state.data = payload;

      const cnpj = payload?.data?.cnpj_empresa || payload?.cnpj_empresa;
      const uf = getUfFromStores(cnpj);
      state.filter.ufEntrada = uf;
      state.filter.ufSaida = uf;

      if (payload.isFilterEan !== undefined && payload.isFilterEan !== null) {
        state.isFilterEan = payload.isFilterEan;
      }
    },
    handleCloseModalProduct: state => {
      const uf = getUfFromStores();
      state.show = false;
      state.data = {};
      state.filter.ufEntrada = uf;
      state.filter.origem = "ED";
      state.filter.ufSaida = uf;
      state.filter.saida = "SVC";
      state.isFilterEan = true;
    },
    handleChangeFilter: (state, { payload }) => {
      state.filter[payload?.field] = payload?.value;
    },
    handleChangeFilterEanDesc: (state, { payload }) => {
      state.filterEanDesc[payload?.field] = payload?.value;
    },
    handleChangeisFilterEan: (state, { payload }) => {
      state.isFilterEan = payload;
    },
  },
});

export const {
  handleOpenModalProduct,
  handleCloseModalProduct,
  handleChangeFilter,
  handleChangeisFilterEan,
  handleChangeFilterEanDesc,
} = productEanGtinSlice.actions;

export default productEanGtinSlice.reducer;
